import { useTranslation } from 'react-i18next';

const useHelpers = () => {
    const { t } = useTranslation();

    const days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].map((day) => ({
        label: t(`marketing.campaign.${day}` as any),
        value: day,
    }));

    const months = [...Array(12).keys()].map((month) => ({
        label: `${t('marketing.campaign.month', { count: month + 1 })}`,
        value: (month + 1).toString(),
    }));

    const itemsBought = [...Array(10).keys()].map((items) => ({
        label: (items + 1).toString(),
        value: (items + 1).toString(),
    }));

    return { days, months, itemsBought };
};

export default useHelpers;
